//Node Modules
import { useRecoilValueLoadable } from "recoil";
import { useTranslation } from "react-i18next";

//Pages

//BinaryForge Components
import { DevicesProvisioningTable } from "./";
import { DatatableSkeleton } from "../helpers/skeleton";
import { Note } from "../helpers";

//3rd Party Components

//Atoms
import { devicesProvisionListSelector } from "../../atoms/devices";

//Helpers
import { useSensorActuatorLabels } from "../../config/device";

//Other

const DevicesLoader = () => {
	//Recoil
	const { t } = useTranslation();
	const { state, contents } = useRecoilValueLoadable(devicesProvisionListSelector);

	switch (state) {
		case "hasError":
			console.error(contents);
			return (
				<Note
					messageKey={`Error: ${contents.message ? contents.message : contents}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return (
				<DatatableSkeleton
					columns={[
						t("devices.table.name"),
						t("devices.table.id"),
						t("devices.table.zone"),
						t(useSensorActuatorLabels ? "devices.table.sensorType" : "devices.table.input"),
						t(useSensorActuatorLabels ? "devices.table.actuatorType" : "devices.table.output"),
						t("devices.table.installer"),
						t("common.table.createdAt"),
					]}
				/>
			);
		case "hasValue":
			return <DevicesProvisioningTable devicesData={contents} />;
		default:
			return null;
	}
};

export default DevicesLoader;
